import React, { Fragment, useEffect, useState } from 'react'
import inspectionQueries from '../../queries/inspectionQueries'
import { useDispatch, useSelector } from 'react-redux'
import { CalendarRange, Eye, MapPin, UserRound, File, PlusCircle, Search, PlusIcon, Plus, Calendar, Ship, Check, CheckIcon } from 'lucide-react'
import { IconCalendar, IconHelpHexagonFilled, IconHistory, IconQuestionMark, IconUser } from '@tabler/icons-react'
import moment from 'moment'
import BreadCrumbs from '../../components/BreadCrumbs'
import { RouteConstant } from '../../routes/RouteConstant'
import { setInspection, setIsUserWise, setUser } from '../../redux/reducers/masterReducers'
import { useNavigate } from 'react-router-dom'
import { setHeaderText, setLoader } from '../../redux/reducers/optionsReducers'
import Loader from '../../components/Loader'
import toast from 'react-hot-toast'
import ProgressBar from '../../components/ProgressBar'
import { useApi } from '../../components/ApiProvider'
import PdfGenerate from './PdfGenerator'
import { setInspectionData } from '../../redux/reducers/inspectionReducers'
import LoaderSmall from '../../components/LoaderSmall'
import DrawerComponent from '../../components/DrawerComponent'
import Empty from '../../components/Empty'
import ReportModal from './ReportModal'
import SparkleButton from '../../components/SparkleButton'
import dropdownQueries from '../../queries/dropdownQueries'
import AccessRestrictionDialog from '../../components/AccessRestrictionDialog'
import { accessMessages } from '../../constants/accessMessages'

const breadcrumb = [
  {
    label: "Vessels",
    path: RouteConstant.VESSEL,
    roles: ["SADMIN"]
  },
  {
    label: "Vessel Details",
    roles: ["CENG", "CAPT", "2E", "3E", "CMATE", "2M", "3M"],
    path: RouteConstant.VESSELDETAILS
  },
  {
    label: "Inspection History",
  }
]


const InspectionHistory = () => {

  const master = useSelector((state)=> state.master)
  const vessel = useSelector((state)=> state.master.vessel)
  const loader = useSelector((state)=> state.options.loader)
  const user = useSelector((state)=> state.auth.user)

  const [isImportNeed, setIsImportNeed] = useState(false)
  const [selectedVessel, setSelectedVessel] = useState(null)
  const [inspections, setInspections] = useState([])

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const {apiData, setApiDataAndNotify} = useApi()

  useEffect(() => {
    dispatch(setLoader(true))
    dispatch(setHeaderText(`Vessel : ${master?.header}`))
  }, []);

  const [result, setResult] = useState([])

  const inspectionHistory = inspectionQueries.useInspectionHistoryMutationList(
    (res)=>{
      dispatch(setLoader(false))
      setResult(res)
    }
  )

  const dropdown = dropdownQueries.useImportCopyQuestionExclude(
    (res)=>{}
  )

  useEffect(() => {
    inspectionHistory.mutateAsync(vessel?.id)
  }, [apiData]);

  useEffect(() => {
    dropdown.mutateAsync({vessel})
  }, []);

  useEffect(() => {
    if (selectedVessel) {
      const vessel = dropdown?.data?.vessels?.find(
        element => element.id === Number(selectedVessel)
      );

      if (vessel && vessel?.inspection_histories?.length > 0) {
        const filterData = vessel?.inspection_histories?.map(inspection => ({
          id: inspection?.id,
          name: moment(inspection?.due_date).format('Do MMM YYYY')
        }));
        console.log(vessel?.inspection_histories)
        setInspections(filterData);
      } else {
        setInspections([]);
      }
    }else{
      setInspections([]);
    }
  }, [selectedVessel]);


  const inputFields = [
    {
      name: "due_date",
      label: "Due Date",
      type: "date",
      required: true,
      grid: 12
    },
    {
      name: "label_copy",
      label: `Do you need import questions`,
      type: "checkbox",
      required: false,
      setState: setIsImportNeed
    },
    {
      name: "vessel_details",
      label: "Select Vessel",
      type: "select",
      required: false,
      options: dropdown?.data?.vessels,
      setState: setSelectedVessel,
      grid: 12,
      hide: !isImportNeed
    },
    {
      name: "inspection_details",
      label: "Select Inspection",
      type: "select",
      required: false,
      options: inspections,
      grid: 12,
      hide: !isImportNeed
    }
  ]

  const handleChapter =(item)=>{ 
    dispatch(setInspection(item.id))
    dispatch(setIsUserWise(false))
    dispatch(setUser({}))
    navigate(RouteConstant.CHAPTERPROGRESS)
  }

  const handleExcludeQuestions = (item)=>{
    dispatch(setInspection(item.id))
    dispatch(setIsUserWise(false))
    dispatch(setUser({}))
    dispatch(setHeaderText(`Vessel : ${master?.header} ( ${moment(item?.due_date).format('DD-MM-YYYY')} )`))
    navigate(RouteConstant.EXCLUDEQUESTIONS)
  }

  const inspectionExport = inspectionQueries.useVesselinspectionExport(
    async(res)=>{
        dispatch(setInspectionData(res?.data))
        navigate(RouteConstant.INSPECTIONREPORT)
    }
  )

  const handleNavigate = async(id)=>{
    await inspectionExport.mutateAsync({vessel:vessel.id, inspection:id})
  }

  const createMaster = inspectionQueries.useInspectionMutationCreate(
    (res)=>{
        if(res?.message === "Error"){
            {res?.error?.map((error, index) => (
              Object?.values(error).map((errorMessage, innerIndex) => (
                  toast.error(errorMessage)
                  ))
              ))}
            return
        }
        if(res?.message !== "Success"){
            toast.error("Something went wrong")
            return
        }
        if(res?.message=== "Success"){
            setApiDataAndNotify(res)
            toast.success("Successfully created")
        }
    }
  )

  if(loader){
    return <Loader />
  }

  return (
    <div className="rounded-xl overflow-hidden backdrop-blur-sm">
      <BreadCrumbs data={breadcrumb} />
      <div className="bg-white bg-opacity-90 rounded-xl overflow-hidden shadow-[0_8px_32px_0_rgba(31,38,135,0.15)] border border-gray-200/50 backdrop-filter backdrop-blur-xl mt-4">
        <div className="px-4 pt-4 pb-4 border-b border-gray-100 relative">
            <div className="flex w-full justify-end items-center gap-4">
            {
              user?.role?.role === "INSPECTOR" &&
              <DrawerComponent vessel_id={vessel.id} entityForm={createMaster} inputFields={inputFields} btnName={'Create Inspection'} header={'Create Inspection'} />
            }
            </div>
        </div>

        <div className="overflow-x-auto">
          {inspectionHistory?.isLoading ? (
            <div className="w-full flex items-center justify-center py-20">
              <LoaderSmall />
            </div>
          ) : (
            <Fragment>
              <table className="w-full">
                <thead>
                  <tr className="bg-gradient-to-r from-gray-50 to-gray-100/80 backdrop-blur-sm">
                    <th className="pl-8 pr-3 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider text-left">#</th>
                    <th className="px-3 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider text-left">Due Date</th>
                    <th className="px-3 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider text-left">Inspection Progress</th>
                    <th className="px-8 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider text-right"></th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {result?.data?.map((row, index) => (
                    <>
                      <tr 
                      key={row?.id} 
                      className="hover:bg-gradient-to-r hover:from-indigo-50/50 hover:to-transparent transition-colors duration-300"
                      >
                        <td className="pl-8 pr-3 py-3 whitespace-nowrap">
                          <div className="flex items-center">
                            <span className="text-sm text-gray-500 font-medium">
                              {index + 1}
                            </span>
                          </div>
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap">
                          <div className="flex items-center gap-3">
                            {moment(row?.due_date).format("DD-MM-YYYY")}
                          </div>
                        </td>
                        <td className="px-3 py-3 whitespace-nowrap">
                          <div className="px-2.5 py-1 rounded-md backdrop-blur-sm text-xs font-medium text-indigo-800 w-fit">
                            {progressFind(row?.successPercentage)}
                          </div>
                        </td>
                        <td className="px-8 py-3 whitespace-nowrap text-right">
                          <div className='gap-2 flex items-center justify-end'>
                            <div className="flex gap-4 justify-end items-center">
                              <SparkleButton
                              handleClick={ ()=> handleChapter(row)}
                              btnName="View"
                              Icon={Eye}
                              />
                              {
                                user.role.role === "INSPECTOR" &&
                                (!result?.isPremium ? 
                                <AccessRestrictionDialog
                                btnName="Manage Questions"
                                content={accessMessages.questionChapterLimit}
                                />
                                :
                                <SparkleButton
                                handleClick={ ()=> handleExcludeQuestions(row)}
                                btnName="Manage Questions"
                                Icon={IconHelpHexagonFilled}
                                />
                              )}
                              <SparkleButton
                              handleClick={ ()=> handleNavigate(row?.id)}
                              btnName="NC Report"
                              Icon={File}
                              />
                              <ReportModal vessel={vessel?.id} id={row?.id} />
                            </div>
                          </div>
                        </td>
                      </tr>
                    </>
                  ))}
                  {!result?.data && (
                    <tr>
                      <td colSpan="7" className="px-4 py-12">
                        <div className="flex flex-col items-center justify-center text-center">
                          <Empty />
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  )
}

export default InspectionHistory

const progressFind =(successPercentage)=>{
  if(isNaN(successPercentage) || successPercentage === undefined || successPercentage === null){
    return <ProgressBar data={0} />
  }else{
    return <ProgressBar data={successPercentage} />
  }
}